
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.167 7.667v5.166h2.166V7.667H2.167zm-.992-.992c.219-.219.516-.342.825-.342h3c.368 0 .667.299.667.667v6.5a.667.667 0 01-.667.667H2A1.167 1.167 0 01.833 13V7.5c0-.31.123-.606.342-.825z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.904 1.702a.667.667 0 01.596-.369A2.667 2.667 0 0110.167 4v.833H13.5a1.668 1.668 0 011.653 1.875l-.75 6a1.668 1.668 0 01-1.653 1.459H5a.667.667 0 010-1.334h7.75a.334.334 0 00.33-.291l.75-6a.337.337 0 00-.193-.346.333.333 0 00-.137-.03h-4a.667.667 0 01-.667-.666V4a1.333 1.333 0 00-.95-1.277L5.597 7.298a.667.667 0 11-1.192-.596l2.5-5z","fill":"#282E3E"}})])
          )
        }
      }
    